/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-named-as-default */
// eslint-disable-next-line import/no-named-as-default-member
import { ApiPrefixV1, ApiV1Base, ApiPrefix } from 'util/icwUtility';
import Request from './request';

export const apiGetSuppliers = async (params) => {
  return Request.call({
    url: '/suppliers/list',
    method: 'GET',
    params,
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};
export const apiGetProductCategories = async (params) => {
  return Request.call({
    url: '/productCategories',
    method: 'GET',
    params,
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};
export const apiGetFactoryList = async (id, params) => {
  return Request.call({
    url: `/product/factory/list/${id}`,
    method: 'GET',
    params,
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};
export const apiGetBuyerList = async (id, params) => {
  return Request.call({
    url: `/product/buyer/list/${id}`,
    method: 'GET',
    params,
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};
export const apiAddProduct = async (data) => {
  return Request.call({
    url: `/micro/products`,
    method: 'POST',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    data,
  });
};
export const apiUpdateProduct = async (id, data) => {
  return Request.call({
    url: `/micro/products/${id}`,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    method: 'PUT',
    data,
  });
};
export const apiCreateSupplier = async (data) => {
  return Request.call({
    url: `/product/supplier/create`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};
export const apiUpdateSupplier = async (id, data) => {
  return Request.call({
    url: `/suppliers/${id}/update`,
    method: 'PUT',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};
export const apiUpdateParticularProduct = async (id, data) => {
  return Request.call({
    url: `/product/${id}`,
    method: 'PATCH',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};
export const apiGetReasons = async () => {
  return Request.call({
    url: `/micro/inspections/waive-reasons`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiAddReason = async (data) => {
  return Request.call({
    url: `/micro/inspections/waive-reasons`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
